/* import __COLOCATED_TEMPLATE__ from './question.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestion extends Component {
  @service prescreener;

  get clientType() {
    return this.args.clientType;
  }

  get validationModel() {
    return this.prescreener.validation.getValidatedAnswerModel(this.args.question, this.clientType);
  }

  get isInvalid() {
    const validation = this.validationModel?.validations?.attrs?.value;
    return validation?.isInvalid && this.showForcedValidation;
  }

  get showForcedValidation() {
    return this.prescreener.validation.forceValidation;
  }
}
